import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../common/ui/Button'

const ResetAllFiltersButton = ({ onClick }) => (
  <Button
    className     = "primary basic clear-all"
    role          = "button"
    clickHandler  = {onClick}
  >
    Clear All
  </Button>
)

ResetAllFiltersButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default ResetAllFiltersButton